import { AfterContentChecked, Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { CustomerObjectsService } from "../../../../../../categories/customer-objects/customer-objects.service";
import { CustomerObjectRelatedRequestDto } from "../../../../../models/customerObject/customer-object-related-request-dto";
import { PerfectScrollbarComponent } from "ngx-perfect-scrollbar";
import { Router } from "@angular/router";

@Component({
	selector: 'request-page-customer-object-requests',
	templateUrl: './request-page-customer-object-requests.component.html',
	styleUrls: ['./request-page-customer-object-requests.component.scss',
		'../../../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'../../../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
	]
})
export class RequestPageCustomerObjectRequestsComponent implements OnInit, OnChanges {
	
	@Input() requestId: number;
	@Input() customerObjectId: number;

	relatedRequests: CustomerObjectRelatedRequestDto[] = [];

	loading: boolean = false;
	cardOpened: boolean = false;

	constructor (
		private customerObjectsService: CustomerObjectsService
	) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.requestId || changes.customerObjectId) {
			this.initData();
		}
	}

	ngOnInit(): void {
		this.initData();
	}

	initData() {
		this.loading = true;
		this.customerObjectsService.getCustomerObjectRelatedRequests(this.customerObjectId, this.requestId).subscribe(resp => {
			this.relatedRequests = resp.filter(x => x.requestId != this.requestId);
			this.loading = false;
		});
	}
	
    public rowClass() {
		return {
			'cursor-pointer': true
		};
	}

	cellClick({ dataItem }: any) {
		window.open(`/requests/${dataItem.requestId}`, '_blank');
	}

	toggleCard() {
		this.cardOpened = !this.cardOpened;
	}
}
